import { useMemo, useEffect, useState, ReactNode, ReactElement } from "react";

interface Polyfill {
  isNeeded: () => boolean;
  load: (locale: string) => void;
}

export function EnsurePolyfilled({
  locale,
  polyfills,
  children,
}: {
  locale: string;
  polyfills: Polyfill[];
  children: ReactNode;
}): ReactElement {
  const neededPolyfills = useMemo(
    () =>
      typeof window === "undefined"
        ? []
        : polyfills.filter((polyfill) => polyfill.isNeeded()),
    [polyfills]
  );

  const [polyfillsLoaded, setPolyfillsLoaded] = useState(
    neededPolyfills.length === 0
  );

  useEffect(() => {
    if (neededPolyfills.length > 0) {
      (async () => {
        await Promise.all(
          neededPolyfills.map((polyfill) => polyfill.load(locale))
        );
        setPolyfillsLoaded(true);
      })();
    }
  }, [neededPolyfills, locale]);

  if (polyfillsLoaded) {
    return <>{children}</>;
  }

  // FIXME: styling, i18n
  return <div>One moment...</div>;
}
